import React from "react";
import { TID } from "../lib/testIds";

const ITEMS = [
  "Helios Labs",
  "Northwind",
  "Vector Cloud",
  "Atlas Capital",
  "Lumen Health",
  "Quanta",
  "Aperture",
  "Forge OS",
  "Sentinel AI",
  "Mercury",
];

export default function LogoMarquee() {
  const list = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid={TID.marquee}
      className="relative border-y border-hairline bg-surface py-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center gap-12 text-[11px] tracking-[0.28em] uppercase text-muted-x font-mono-x mb-8">
        <span>Trusted by teams shipping at scale</span>
        <span className="h-px flex-1 bg-hairline" />
      </div>
      <div className="relative">
        <div className="flex whitespace-nowrap marquee">
          {list.map((name, i) => (
            <div
              key={i}
              className="px-10 flex items-center gap-3 text-secondary-x hover:text-primary-x transition-colors"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-hairline-strong" />
              <span className="font-display text-2xl md:text-3xl font-medium tracking-tight">
                {name}
              </span>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 fill-canvas-fade" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 fill-canvas-fade" style={{ background: "linear-gradient(to left, var(--canvas), transparent)" }} />
      </div>
    </section>
  );
}
